import { redirect, type RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { contractsLoader } from './contracts-loader';

export const contractsRoutes: RouteObject = {
  loader: contractsLoader,
  children: [
    {
      path: '/contracts/:id',
      lazy: lazyComponent(
        () => import('@pages/client/contract/contract-page'),
        'ContractPage',
      ),
      children: [
        {
          index: true,
          loader: ({ params }) => redirect(`/contracts/${params.id}/details`),
        },
        {
          path: 'details',
          lazy: lazyComponent(
            () => import('@pages/client/contract/contract-page'),
            'ContractDetails',
          ),
        },
        {
          path: 'cards',
          lazy: lazyComponent(
            () => import('@pages/client/contract/contract-page'),
            'ContractCards',
          ),
        },
        {
          path: 'transactions',
          lazy: lazyComponent(
            () => import('@pages/client/contract/contract-page'),
            'ContractTransactions',
          ),
        },
        {
          path: 'accounts',
          lazy: lazyComponent(
            () => import('@pages/client/contract/contract-page'),
            'ContractAccounts',
          ),
        },
        {
          path: 'documents',
          lazy: lazyComponent(
            () => import('@pages/client/contract/contract-page'),
            'ContractDocuments',
          ),
        },
        {
          path: 'discounts',
          lazy: lazyComponent(
            () => import('@pages/client/contract/contract-page'),
            'ContractDiscounts',
          ),
        },
      ],
    },
    {
      path: '/contracts',
      lazy: lazyComponent(
        () => import('@pages/client/contract/contracts-page'),
        'ContractsPage',
      ),
    },
  ],
};
